import { appStores } from "../siteContent";

function StorePlatform({ platform }) {
  const isAndroid = platform === "android";

  return (
    <span className="hero-download-platform" aria-hidden="true">
      {isAndroid ? (
        <svg className="hero-store-icon" viewBox="0 0 24 24" focusable="false">
          <path d="M7 8h10a2 2 0 0 1 2 2v6.5a2 2 0 0 1-2 2h-1V21a1 1 0 0 1-2 0v-2.5h-4V21a1 1 0 0 1-2 0v-2.5H7a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2Z" />
          <path d="m8 7-1.4-2M16 7l1.4-2M8.5 11.5h.01M15.5 11.5h.01" />
        </svg>
      ) : (
        <svg className="hero-store-icon" viewBox="0 0 24 24" focusable="false">
          <rect x="6" y="2" width="12" height="20" rx="3" />
          <path d="M10 5h4M10 19h4" />
        </svg>
      )}
    </span>
  );
}

export function StoreDownloadActions({ className = "" }) {
  return (
    <div className={`hero-download-actions ${className}`} aria-label="Download Aspirant mobile apps">
      <a
        href={appStores.android.url}
        className="button hero-download-button hero-download-android"
        target="_blank"
        rel="noreferrer"
        aria-label="Download Aspirant Android app from Google Play"
      >
        <span className="hero-download-copy">Download Android App</span>
        <StorePlatform platform="android" />
      </a>
      <a
        href={appStores.ios.url}
        className="button hero-download-button hero-download-ios"
        target="_blank"
        rel="noreferrer"
        aria-label="Download Aspirant CSS app from the Apple App Store"
      >
        <span className="hero-download-copy">Download iOS App</span>
        <StorePlatform platform="ios" />
      </a>
    </div>
  );
}
